import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface BreadcrumbItem {
  label: string;
  route?: string;
  callback?: () => void;
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  readonly breadcrumbs$ = new BehaviorSubject<BreadcrumbItem[]>([]);

  set(items: BreadcrumbItem[]) {
    this.breadcrumbs$.next(items);
  }

  clear() {
    this.breadcrumbs$.next([]);
  }
}
